export enum ORDER_URLS {
  CREATE_ORDER = '/campaign/:code/purchase',
}
